module.exports = __webpack_public_path__ + "img/thumbs-up.3b246af1.svg";